var _defs, _path, _rect, _circle, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE3F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mercury",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E11D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FB7185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBA74"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bulb",
    cx: 0.35,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF8FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E11D48"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10a8 8 0 0 1 16 0v26.5a13 13 0 1 1-16 0z",
    fill: "url(#glass)",
    stroke: "#B8C2D6",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 18,
    width: 7,
    height: 24,
    rx: 3.5,
    fill: "url(#mercury)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 47,
    r: 9,
    fill: "url(#bulb)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 43.5a5 5 0 0 1 4-2.5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9v22",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 14h6M44 21h4M44 28h6M44 35h4",
    stroke: "#8B95AA",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.cfe04e44f1d91409d3c72e9a5e3da0da.svg";
export { ForwardRef as ReactComponent };